import { createSlice } from "@reduxjs/toolkit";

const initialAnalyticsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  usersAnalytics: [],
  avatarslist: [],
  avatarselected: [],
  totalversions: [],
  totalcolleges: [],
  totalfollowers: [],
  totalfollowings: [],
  emailAnalytics: [], 
  pushAnalytics: [], 
  usersRetentionAnalytics: [],
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const AnalyticsSlice = createSlice({

  name: "analytics",
  initialState: initialAnalyticsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },

    usersAnalyticsData: (state, action) => {
      const { usersAnalytics } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.usersAnalytics = usersAnalytics;
    },
    mainDashboardFetchedTotalVersion: (state, action) => {
      const { totalversions } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.totalversions = totalversions;
    },
    mainDashboardFetchedAvatarsList: (state, action) => {
      const { avatarslist } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.avatarslist = avatarslist;
    },
    mainDashboardFetchedAvatarsSelected: (state, action) => {
      const { avatarselected } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.avatarselected = avatarselected;
    },
    mainDashboardFetchedTotalColleges: (state, action) => {
      const { totalcolleges } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.totalcolleges = totalcolleges;
    },
    mainDashboardFetchedTotalFollowers: (state, action) => {
      const { totalfollowers } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.totalfollowers = totalfollowers;
    },
    mainDashboardFetchedTotalFollowings: (state, action) => {
      const { totalfollowings } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.totalfollowings = totalfollowings;
    },
    mainDashboardFetchedContestRatings: (state, action) => {
      const { contestratings } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.contestratings = contestratings;
    },
    emailRetentionAnalyticsData: (state, action) => {
      const { emailAnalytics } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.emailAnalytics = emailAnalytics;
    },
    pushRetentionAnalyticsData: (state, action) => {
      const { pushAnalytics } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.pushAnalytics = pushAnalytics;
    },
    usersRetentionAnalyticsData: (state, action) => {
      const { usersRetentionAnalytics } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.usersRetentionAnalytics = usersRetentionAnalytics;
    },
  }
});
